import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import { getRecipeCategoryLabel } from 'Pages/manageproduction/helpers/productionRecord';
import {
  CommonSectionPropTypes,
  MealSectionGridFields,
} from 'Pages/manageproduction/helpers/Constants';
import { MealSectionRow } from './MealSectionRow';

class MealSection extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    sticky: PropTypes.bool,
    ...CommonSectionPropTypes,
  };

  static defaultProps = {
    className: '',
    sticky: false,
  };

  static get columnLabels() {
    return [
      'Category',
      'Recipe ID',
      'Meal Contributions',
      'Serving Size',
      'Units / 100 Servings',
    ];
  }

  static get stickyColumnLabels() {
    return ['Category', 'Recipe ID'];
  }

  renderRows = () => {
    const {
      isReadOnly,
      detailsByRecipeCategory,
      hookDispatch,
      sticky,
      onInputChange,
    } = this.props;
    let itemsToRender = [];

    // Starts from 2 to account for header row
    let index = 2;

    Object.keys(detailsByRecipeCategory).forEach((recipeCategoryId) => {
      const detailsInCategory = detailsByRecipeCategory[recipeCategoryId];
      const category = getRecipeCategoryLabel(recipeCategoryId);

      itemsToRender.push(
        <div className="divider-row" key={index}>
          <div className="grid-item">{category}</div>
        </div>
      );
      index += 1;

      const categoryItems = [];

      detailsInCategory.forEach((detail) => {
        const content = (
          <div className="grid-row" key={index}>
            <MealSectionRow
              {..._.pick(detail, MealSectionGridFields)}
              disabled={isReadOnly}
              sticky={sticky}
              hookDispatch={hookDispatch}
              onInputChange={onInputChange}
              detail={detail}
            />
          </div>
        );
        index += 1;

        categoryItems.push(content);
      });

      itemsToRender = itemsToRender.concat(categoryItems);
    });

    return itemsToRender;
  };

  render() {
    const { className, forwardedRef, sticky, style } = this.props;

    const gridClass = classNames(
      'ep-meal-grid',
      sticky && 'sticky-meal-section',
      className
    );

    const labels = sticky
      ? MealSection.stickyColumnLabels
      : MealSection.columnLabels;

    return (
      <div className={gridClass} ref={forwardedRef} style={style}>
        <div className="grid-row grid-title-row">Recipes</div>
        <div className="grid-header grid-row">
          {labels.map((label, i) => (
            <div className="grid-item" key={i}>
              {label}
            </div>
          ))}
        </div>
        {this.renderRows()}
      </div>
    );
  }
}

const MealSectionWithRef = React.forwardRef((props, ref) => {
  return <MealSection {...props} forwardedRef={ref} />;
});

export { MealSectionWithRef as MealSection };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/MealSection.js